import { rankingItems } from '@/mocks/homeData';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-green-600',
  down: 'ri-arrow-down-line text-red-500',
  new: 'ri-sparkling-line text-accent-500',
  same: 'ri-subtract-line text-foreground-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          热播排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          基于播放量与用户评分的实时热度榜单
        </p>

        <div className="bg-background-100 rounded-lg overflow-hidden">
          <div className="grid grid-cols-12 gap-3 px-5 py-3 text-xs font-semibold text-foreground-500 border-b border-background-200/60">
            <span className="col-span-1">排名</span>
            <span className="col-span-5">作品</span>
            <span className="col-span-3">类型</span>
            <span className="col-span-2">评分</span>
            <span className="col-span-1">趋势</span>
          </div>

          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-12 gap-3 px-5 py-4 items-center border-b border-background-200/40 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <span className={`col-span-1 text-sm font-bold font-heading ${
                item.rank <= 3 ? 'text-primary-500' : 'text-foreground-500'
              }`}>
                {item.rank <= 3 ? `0${item.rank}` : item.rank}
              </span>
              <span className="col-span-5 text-sm font-medium text-foreground-900">
                {item.title}
              </span>
              <span className="col-span-3 text-xs text-foreground-600">
                {item.category}
              </span>
              <span className="col-span-2 text-sm font-semibold text-accent-600">
                {item.score}
              </span>
              <span className="col-span-1 flex items-center gap-1">
                <i className={`text-sm ${trendIcon[item.trend]}`}></i>
                <span className="text-xs text-foreground-500">{item.change}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}